import { I18nLink } from '@stape-io/promo-shared-content';
import { PropsWithChildren } from 'react';

import styles from './ResultSearchItemWrapper.module.scss';

interface ResultSearchItemProps extends PropsWithChildren {
  url: string;
}

export function ResultSearchItemWrapper({ url, children }: ResultSearchItemProps) {
  return (
    <I18nLink href={url} className={styles.resultSearchWrapper}>
      {children}
    </I18nLink>
  );
}
